import Authentication from './Authentication';
import CaseManager from './CaseManager';
import Contact from './Contact';
import Document from './Document';
import EOB from './EOB';
import FundingRequest from './FundingRequest';
import Participant from './Participant';
import Physician from './Physician';
import Provider from './Provider';
import User from './User';

export const Endpoints = {
  FundingRequest,
  Authentication,
  User,
  Participant,
  Physician,
  Provider,
  Document,
  Contact,
  EOB,
  CaseManager,
};
